export const DEFAULT_FEATURE_FLAGS = {
  showSettings: true,
  showTutorial: true,
  betTicketBorderByBet: true,
};
